import React from "react";

import { StyledDate } from "./date.style";

const Date = ({
  register,
  value,
  name,
  required,
  placeholder,
  minValue,
  maxValue,
  readOnly,
  error,
}) => (
  <StyledDate error={error ? 1 : 0}>
    <input
      type="date"
      {...register(name, {
        required: {
          value: required,
          message: "This field is required",
        },
        value: value,
        min: {
          value: minValue,
          message: `Earliest date that can be set is ${minValue}`,
        },
        max: {
          value: maxValue,
          message: `Latest date that can be set is ${maxValue}`,
        },
      })}
      placeholder={placeholder}
      min={minValue}
      max={maxValue}
      readOnly={readOnly}
    />
    <span className="error">{error?.message || ""}</span>
  </StyledDate>
);

export default Date;
